import * as React from 'react';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingAction } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import Illustration from '../../../../components/Illustration';
import LinkButton from '../../../../components/LinkButton';

interface INoDataPlaceholderProps {
  variant?: 'noActivePositions' | 'noActiveCandidates' | 'default';
  onButtonClick?: IBindingAction;
}

const NoDataPlaceholder: FunctionComponent<INoDataPlaceholderProps> = ({ variant = 'default', onButtonClick }) => (
  variant === 'default' ? (
    <Illustration
      variant="binoculars"
      height="22rem"
      header={<FormattedMessage id="resultsNotFound" defaultMessage="Hmm... no matches found" />}
      description={(
        <FormattedMessage
          id="resultsNotFoundFilterHint"
          defaultMessage="Try adjusting your filters or searching for something else."
        />
      )}
    />
  ) : (
    <Illustration
      variant="sitting"
      height="22rem"
      header={<FormattedMessage id="positionTable.noActivePosition" defaultMessage="Looking a little “bear”..." />}
      description={variant === 'noActivePositions' ? (
        <FormattedMessage
          id="positionTable.noActivePositionHint"
          defaultMessage="You don’t have any active positions. Let’s get started and request some references!"
        />
      ) : (
        <FormattedMessage
          id="positionTable.noActiveCandidateHint"
          defaultMessage="You don’t have any active candidates. Let’s get started and request some references!"
        />
      )}
      button={(
        <LinkButton
          textIntlId="positionTable.newReferenceRequest"
          defaultMessage="New reference request"
          icon={<Icon icon="plus" />}
          iconPosition="right"
          onClick={onButtonClick}
        />
      )}
    />
  )
);

export default NoDataPlaceholder;
